// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#main-settings-wrapper .ant-list-header[data-v-f2bf2ad2]{background-color:#00f;padding:0}.ant-list-item[data-v-f2bf2ad2]{padding:0}#main-settings-wrapper[data-v-f2bf2ad2]{font-weight:400;color:#000}#main-settings-wrapper>.ant-card-head-title[data-v-f2bf2ad2],#main-settings-wrapper h2[data-v-f2bf2ad2]{font-weight:500;color:#000}#main-settings-wrapper .sett-select[data-v-f2bf2ad2]{font-size:1rem}.ant-btn-primary[data-v-f2bf2ad2]{color:#fff!important}", ""]);
// Exports
module.exports = exports;
